import { RootState } from 'handlers';

export const getReferralLinkState = (state: RootState) => state.referralLink;
